import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import {
    Row,
    Col,
    Label,
    Input,
    InputGroup
} from "reactstrap";
import Select from 'react-select';
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import { templateHelper } from "../../../template/helpers/templateHelper";
import { emailActions } from "../../../../../store/actions/cms/email/email.action";
import { setValueToNestedObject, deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import { UseTemplateButton, SetStyleToAllOfItsType, SetToAuto } from "../../components/UseTemplateButton";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import { emailFonts } from "../../models/emailFonts/emailFonts";
import { simpleButtonHandler } from "./SimpleButton.handler";


class SimpleButtonSettings extends React.Component {
    state = {
        spreadActiveSet: []
    }
    handleSoftUpdate = element => {
        const { dispatch } = this.props;
        dispatch(emailActions.updateEmailElement(element, null, true, this.props.inherit));
    }
    useTemplateStyle = (stylePath, templatePath) => {
        const { selectedElement, template } = this.props;
        let elementCopy = deepClone(selectedElement);
        let templateCopy = deepClone(template)
        const styleParts = stylePath.split(".");
        const templateParts = templatePath.split(".");

        let unit = templateHelper.getUnit(templateCopy, templateParts);
        let value = templateHelper.getValueWithoutUnit(templateCopy, templateParts);

        if (parseInt(value) && unit.length < 4) {
            value += unit;
        }

        elementCopy.style = setValueToNestedObject(
            styleParts,
            value,
            elementCopy.style
        );
        elementCopy.style.inheritedStyles.push({ templatePath, stylePath });

        this.handleSoftUpdate(elementCopy);

        if (this.state.spreadActiveSet.includes(styleParts[styleParts.length - 1]) || this.state.spreadActiveSet.includes(styleParts[styleParts.length - 2] + styleParts[styleParts.length - 1])) {
            this.spreadStyle(elementCopy.type, styleParts, value, templatePath)
        }

    }
    inheritedStylesControl = (selectedElement, val, templatePath, stylePath) => {
        const { template } = this.props;
        if (!selectedElement.style.inheritedStyles ||
            selectedElement.style.inheritedStyles.length === 0) {
            return;
        }
        let templateCopy = deepClone(template)
        const newElement = deepClone(selectedElement);
        const templateParts = templatePath.split(".");
        let unit = templateHelper.getUnit(templateCopy, templateParts);
        let value = templateHelper.getValueWithoutUnit(templateCopy, templateParts);
        if (parseInt(value) && unit.length < 4) {
            value += unit;
        }

        if (value !== val) {
            newElement.style.inheritedStyles = newElement.style.inheritedStyles.filter(s => s !== templatePath);
        }
        else {

            newElement.style.inheritedStyles.push({ templatePath: templatePath, stylePath: stylePath })
        }
        return newElement;
    }
    spreadStyle = (type, parts, value, templatePath = null) => {
        const { selectedElement } = this.props;
        const elementsCopy = Array.from(this.props.elements);
        if (elementsCopy.length === 0) return;
        const typeFamily = elementsCopy.filter(el => el.type === type);
        if (typeFamily.length > 0) {
            typeFamily.map(tf => {
                let newEl = deepClone(tf);
                newEl.style = setValueToNestedObject(
                    parts,
                    value,
                    newEl.style
                );
                if (templatePath && Array.isArray(newEl.style.inheritedStyles)) {
                    newEl = this.inheritedStylesControl(
                        newEl,
                        value,
                        templatePath,
                        parts.join('.'))
                }
                this.handleSoftUpdate(newEl);
            });
        }
        if (selectedElement.families.length > 0) {
            const typeFamilyTree = elementsCopy.filter(el => el.families && el.families.length > 0 && el.id !== selectedElement.id);
            if (typeFamilyTree.length === 0) return;
            selectedElement.families.map(f => {
                typeFamilyTree.map(tf => {
                    if (tf.families.includes(f)) {
                        let newEl = deepClone(tf);
                        if (tf.families.length > 1) {
                            if (newEl.style[f + 'Style'] !== undefined) {
                                newEl.style = setValueToNestedObject(
                                    [f + 'Style', parts[parts.length - 1]],
                                    value,
                                    newEl.style
                                );
                            }
                        }
                        else {
                            if (newEl.style.styleProps !== undefined) {
                                newEl.style = setValueToNestedObject(
                                    ['styleProps', parts[parts.length - 1]],
                                    value,
                                    newEl.style
                                );
                            }
                        }
                        if (templatePath && Array.isArray(newEl.style.inheritedStyles)) {
                            newEl = this.inheritedStylesControl(
                                newEl,
                                value,
                                templatePath,
                                tf.families.length > 1 ?
                                    [f + 'Style', parts[parts.length - 1]].join('.') :
                                    ['styleProps', parts[parts.length - 1]].join('.'))
                        }
                        this.handleSoftUpdate(newEl);
                    }
                })
            })

        }
    }
    handleChange = (e, val, path, templatePath = null) => {
        const { selectedElement } = this.props;
        const names = path.split(".");
        let elementCopy = deepClone(selectedElement);
        let value = val;
        if (val && val.hex !== undefined) {
            value = templateHelper.parseRgbaToHex(val)
        }
        if (templatePath !== null) {
            elementCopy = this.inheritedStylesControl(elementCopy, value, templatePath, path)
        }
        elementCopy.style = setValueToNestedObject(
            names,
            value,
            elementCopy.style
        );
        elementCopy.content = simpleButtonHandler.elementEditor(elementCopy.style);
        this.handleSoftUpdate(elementCopy);
        if (this.state.spreadActiveSet.includes(names[names.length - 1]) || this.state.spreadActiveSet.includes(names[names.length - 2] + names[names.length - 1])) {
            this.spreadStyle(elementCopy.type, names, value, templatePath)
        }
    }
    spreadToggler = (name) => {
        let spreadActiveSet = Array.from(this.state.spreadActiveSet);
        if (spreadActiveSet.includes(name)) {
            spreadActiveSet = spreadActiveSet.filter(n => { return n !== name });
        }
        else {
            spreadActiveSet.push(name)
        }
        this.setState({ spreadActiveSet });
    }
    handleSpaceOnChange = (e, path, dir) => {
        const names = path.split(".");
        const elementCopy = deepClone(this.props.selectedElement);
        const spaceValue = elementCopy.style[names[0]][names[1]];
        let value = e.target.value;
        let splitted = spaceValue.toString().split(' ')
        let baseValue = '';
        if (splitted.length > 1) {
            splitted[dir] = value + 'px';
            splitted = splitted.join(' ')
            baseValue = splitted;
            elementCopy.style = setValueToNestedObject(
                names,
                splitted,
                elementCopy.style
            );
        }
        else {
            let newString = `${splitted[0]}px ${splitted[0]}px ${splitted[0]}px ${splitted[0]}px`;
            newString = newString.split(' ');
            newString[dir] = value + 'px';
            baseValue = newString;
            elementCopy.style = setValueToNestedObject(
                names,
                newString,
                elementCopy.style
            );
        }
        this.handleSoftUpdate(elementCopy);
        if (this.state.spreadActiveSet.includes(names[names.length - 1]) || this.state.spreadActiveSet.includes(names[names.length - 2] + names[names.length - 1])) {
            this.spreadStyle(elementCopy.type, names, baseValue)
        }
    }
    convertSpaceValue = (value, index) => {
        let splitted = value.toString().split(' ')
        if (splitted.length > 1) {
            return parseInt(splitted[index]);
        }
        else {
            return parseInt(splitted[0]);
        }
    }
    render() {
        const { selectedElement, template } = this.props;
        const selectStyles = {
            option: (styles, { data }) => {
                return {
                    ...styles,
                    fontSize: '12px',
                    fontFamily: data.value,
                    padding: "0 10px",
                };
            },
            container: styles => ({
                ...styles,
                minWidth: "100%",
                borderRight: '1px solid gainsboro'
            }),
            /*       control: styles => ({
                      borderWidth: '1px'
                  }), */
            singleValue: (styles, { data }) => {
                return {
                    ...styles,
                    fontSize: '12px',
                    fontFamily: data.value,
                };
            }
        };
        return (
            <React.Fragment>
                <ListExpansion
                    footer={false}
                    icon="fa fa-image"
                    description="Colors"
                    defaultExpanded={true}
                >
                    <Row>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="BackgroundColor" />
                            </Label>

                        </Col>
                        <Col className="list-setting-item-item">
                            <ColorPickerFacade
                                color={selectedElement.style.wrapper.backgroundColor}
                                path={"wrapper.backgroundColor"}
                                onChange={(color, e) =>
                                    this.handleChange(e, color, "wrapper.backgroundColor", 'content.backgroundColor')
                                }
                            />
                        </Col>
                        <br />
                    </Row>
                    <Row>
                        <Col className="list-setting-item-title curved-panel-stack">
                            {template.content.content.backgroundColor !== 'unset' ? <UseTemplateButton
                                onClick={
                                    () => this.useTemplateStyle(
                                        "wrapper.backgroundColor",
                                        "content.backgroundColor"
                                    )}
                                active={(selectedElement.style.wrapper.backgroundColor === template.content.content.backgroundColor)}
                            /> : null}
                            <SetStyleToAllOfItsType
                                onClick={() => this.spreadToggler('wrapperbackgroundColor')}
                                active={this.state.spreadActiveSet.includes('wrapperbackgroundColor')}
                            />
                            <br />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="ButtonColor" />
                            </Label>

                        </Col>
                        <Col className="list-setting-item-item">
                            <ColorPickerFacade
                                color={selectedElement.style.styleProps.background}
                                path={"styleProps.background"}
                                onChange={(color, e) =>
                                    this.handleChange(e, color, "styleProps.background", 'button.backgroundColor')
                                }
                            />
                        </Col>
                        <br />
                    </Row>
                    <Row>
                        <Col className="list-setting-item-title curved-panel-stack">
                            {template.content.button.backgroundColor !== 'unset' ? <UseTemplateButton
                                onClick={
                                    () => this.useTemplateStyle(
                                        "styleProps.background",
                                        "button.backgroundColor"
                                    )}
                                active={(selectedElement.style.styleProps.background === template.content.button.backgroundColor)}
                            /> : null}
                            <SetStyleToAllOfItsType
                                onClick={() => this.spreadToggler('background')}
                                active={this.state.spreadActiveSet.includes('background')}
                            />
                            <br />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="TextColor" />
                            </Label>
                        </Col>
                        <Col className="list-setting-item-item">
                            <ColorPickerFacade
                                color={selectedElement.style.styleProps.color}
                                path={"styleProps.color"}
                                onChange={(color, e) =>
                                    this.handleChange(e, color, "styleProps.color", 'button.color')
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="list-setting-item-title curved-panel-stack">
                            {template.content.button.color !== 'unset' ? <UseTemplateButton
                                onClick={
                                    () => this.useTemplateStyle(
                                        "styleProps.color",
                                        "button.color"
                                    )}
                                active={(selectedElement.style.styleProps.color === template.content.button.color)}
                            /> : null}
                            <SetStyleToAllOfItsType
                                onClick={() => this.spreadToggler('color')}
                                active={this.state.spreadActiveSet.includes('color')}
                            />
                        </Col>
                    </Row>
                </ListExpansion>
                <br />
                <ListExpansion
                    footer={false}
                    icon="fa fa-image"
                    description="SizeAndMargins"
                    defaultExpanded={true}
                >
                    <EditorSlider
                        value={selectedElement.style.styleProps.minWidth !== undefined &&
                            selectedElement.style.styleProps.minWidth !== "unset"
                            ? parseFloat(selectedElement.style.styleProps.minWidth)
                            : 0}
                        defaultValue={0}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["px"]}
                        activeUnit={'px'}
                        attachUnit={true}
                        steps={1}
                        max={680}
                        min={1}
                        path={'styleProps.minWidth'}
                        label="ButtonWidth"
                    />
                    <Row>
                        <Col className="list-setting-item-title curved-panel-stack">
                            <SetStyleToAllOfItsType
                                onClick={() => this.spreadToggler('minWidth')}
                                active={this.state.spreadActiveSet.includes('minWidth')}
                            />
                            <br />
                        </Col>
                    </Row>
                    <EditorSlider
                        value={selectedElement.style.styleProps.borderRadius !== undefined &&
                            selectedElement.style.styleProps.borderRadius !== "unset"
                            ? parseFloat(selectedElement.style.styleProps.borderRadius)
                            : 0}
                        defaultValue={0}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["px"]}
                        activeUnit={'px'}
                        attachUnit={true}
                        steps={1}
                        max={100}
                        min={1}
                        extraParam="button.borderRadius"
                        path={'styleProps.borderRadius'}
                        label="BorderRadius"
                    />
                    <Row>
                        <Col className="list-setting-item-title curved-panel-stack">
                            <UseTemplateButton
                                onClick={
                                    () => this.useTemplateStyle(
                                        "styleProps.borderRadius",
                                        "button.borderRadius"
                                    )}
                                active={(selectedElement.style.styleProps.borderRadius === template.content.button.borderRadius)}
                            />
                            <SetStyleToAllOfItsType
                                onClick={() => this.spreadToggler('borderRadius')}
                                active={this.state.spreadActiveSet.includes('borderRadius')}
                            />
                            <br />
                        </Col>
                    </Row>
        

                </ListExpansion>
                <br />
                <ListExpansion
                    footer={false}
                    icon="fa fa-image"
                    description="Links"
                    defaultExpanded={true}
                >
                    <Row>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="LinksAndText" />
                            </Label>
                        </Col>
                    </Row>
                 {/*    <UrlMultiInput margin={false} externalSourceOnly={true} onChange={this.handleChange} path={'elementProps.link'} url={selectedElement.style.elementProps.link} /> */}
                    <UrlMultiInput
                        margin={false} externalSourceOnly={true}
                        linkHelper={true}
                        path={'elementProps.link'} 
                        onChange={this.handleChange}   url={selectedElement.style.elementProps.link}  />
                    <Row >
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="FontFamily" />
                            </Label>
                        </Col>
                    </Row>
                    <Row >
                        <Col className="list-setting-item-title" style={{ lineHeight: 'unset' }}>
                            <InputGroup style={{ display: 'inline-flex', flexWrap: 'nowrap', alignItems: 'unset', maxWidth: '100%' }}>
                                <Select
                                    className="jirango-fontpicker no-prepend"
                                    classNamePrefix="jirango-fontpicker"

                                    options={emailFonts()}
                                    value={{ value: selectedElement.style.styleProps.fontFamily, label: selectedElement.style.styleProps.fontFamily }}
                                    onChange={selectedOption =>
                                        this.handleChange(null, selectedOption.value, 'styleProps.fontFamily')
                                    }
                                    styles={selectStyles}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="list-setting-item-title curved-panel-stack">
                            <SetStyleToAllOfItsType
                                onClick={() => this.spreadToggler('fontFamily')}
                                active={this.state.spreadActiveSet.includes('fontFamily')}
                            />
                            <br />
                        </Col>
                    </Row>
                </ListExpansion>
            </React.Fragment>
        );
    }
}
function mapStateToProps(state) {
    return {
        elements: state.email.elements,
        template: state.template.template,
        inherit: state.email.inherit,
        selectedElement: state.email.selectedElement
    };
}
export default connect(mapStateToProps)(SimpleButtonSettings);
